<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="11">
          <div class="page-title">學生帳號列表</div>
        </el-col>
      </el-row>
      <div class="page-content">
        <div class="page-box">
          <div class="page-content-row">
            <div >
              <div class="search-text">學生帳號</div>
              <el-input
                v-model="listQuery.userNoLike"
                placeholder="搜尋學生帳號"
              ></el-input>
            </div>
            <div >
              <div class="search-text">學生姓名</div>
              <el-input
                v-model="listQuery.nameLike"
                placeholder="搜尋學生姓名"
              ></el-input>
            </div>
            <div style="display: none">
              <div class="search-text">性別</div>
              <el-select v-model="listQuery.gender" clearable placeholder="全部">
                <el-option
                  v-for="(item, index) in genders"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div >
              <div class="search-text">分校</div>
              <el-select
                v-model="listQuery.branchSchoolId"
                clearable
                placeholder="請選擇分校"
              >
                <el-option
                  v-for="(item, index) in sortBranchesList"
                  :key="index"
                  :label="item.abbreviation"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div >
              <div class="search-text">分校學生編號</div>
              <el-input
                v-model="listQuery.studentCodeLike"
                placeholder="搜尋分校學生編號"
              ></el-input>
            </div>
            <div >
              <div class="search-text">年級</div>
              <el-select v-model="listQuery.gradeId" clearable placeholder="全部">
                <el-option
                  v-for="(item, index) in grades"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div >
              <div class="search-text">用戶電郵地址</div>
              <el-input
                v-model="listQuery.parentEmailLike"
                placeholder="搜尋電郵地址"
              ></el-input>
            </div>
            <div >
              <el-button type="info" class="button-el-el" @click.native="onSearch"
                >搜尋</el-button
              >
            </div>
            <div >
              <el-button
                type="success"
                class="button-el-el"
                @click.native="onReset"
                >清除</el-button
              >
            </div>
            <div >
              <el-button type="info" @click="onDownload" class="button-el-el">下載</el-button>
            </div>
            <div>
              <el-button type="info" class="button-el-el" @click="batchSelect">批量轉校HQ</el-button>
            </div>
          </div>
        </div>

        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column> <!-- 添加复选框列 -->
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column
            prop="avatar"
            label="頭像"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <img :src="scope.row.avatar" min-width="70" height="70" />
            </template>
          </el-table-column>
          <el-table-column
            prop="userNo"
            label="學生帳號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="學生姓名"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="帳號狀態"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{ row }">
              <span :class="{'studentCode': row.status==1,'isStudentCode':row.status==0}">{{ row.status | studentCodeStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="status"
              label="訂閱狀態"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{ row }">
              <span :class="{'studentCode': row.subscriptionStatus==1,'isStudentCode':row.subscriptionStatus==0}">
                {{ row.subscriptionStatus | subscriptionStatus }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="gender"
            label="性別"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span>{{ row.gender | gender }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="branchSchoolId" label="分校" align="center" sortable="custom">
            <template slot-scope="{ row }">
              <span v-if="row.branchSchool">{{ row.branchSchool.abbreviation }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="studentCode"
            label="分校學生編號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column prop="gradeId" label="年級" align="center" sortable="custom">
            <template slot-scope="{ row }">
              <span v-if="row.grade">{{ row.grade.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="parentEmail"
            label="用戶電郵地址"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
               <span>{{row.parentEmail}}</span>
          </template>
          </el-table-column>
          <el-table-column
              prop="studying"
              label="課程語言版本"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{row}">
              <span>{{row.studying==0?'繁體語言':'English'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="adminUserInfoRoleId != teacherRoleId"
                size="medium"
                @click="onEditorButton(scope.row.parentId)"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(scope.row.parentId)"
                >詳情</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="goToLearningPerformance(scope.row.id,scope.row.userNo,scope.row.studying)"
                >學習表現</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery._page"
      :limit.sync="listQuery._limit"
      @pagination="getUsers"
    />
  </div>
</template>

<script>
import {getUsers, changeSchools} from "@/api/users";
import Pagination from "@/components/Pagination";
import {downloadFile} from "@/utils/is-rules";
import {getStudentReport} from "@/api/report";
import {getGrades} from '@/api/grade'
export default {
  components: {Pagination },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
    subscriptionStatus(v) {
      return v === 0 ? "無訂閱" : v === 1 ? "訂閱中" : v === 2 ? "過期" : "等待開始";
    },
  },
  data() {
    return {
      selectedRows: [],
      total: 0,
      userId: null,
      listQuery: {
        userNoLike: null,
        nameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        gradeId: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      avatars: [],
      grades: [],
      form: {
        ids: null
      },
    };
  },
  created() {
    this.getUsers();
    this.getGrades();
  },
  methods: {
    // 处理复选框选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log('选中的行数据:', selection);
    },
    batchSelect() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }

      // 通过事件传递选中的多行数据
      // this.$emit('batch-select', this.selectedRows);
      // 如果需要同时触发单行选择事件（可选）
      this.form.ids = this.selectedRows.map(row => row.id).join(',');
      changeSchools(this.form).then(() => {
        this.$message.success("轉校成功");
        this.getUsers();
        this.getGrades();
      });
    },
    getGrades(){
      getGrades().then((res)=>{
        this.grades = res.data
      })
    },
    onDownload(){
      this.getStudentReport()
    },
    getStudentReport() {
      let form = {
          nameLike: this.listQuery.nameLike || null, 
          userNoLike: this.listQuery.userNoLike || null, 
          parentEmailLike: this.listQuery.parentEmailLike || null, 
          gender: this.listQuery.gender, 
          branchSchoolId: this.listQuery.branchSchoolId || null, 
          gradeId: this.listQuery.gradeId || null, 
          studentCodeLike: this.listQuery.studentCodeLike || null
      }
      getStudentReport(form).then((res)=>{
          downloadFile(res.data,'studentReport.xlsx')
      })
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getUsers();
    },
    onSearch() {
      this.getUsers();
    },
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        } else if (key === "_limit") {
          this.listQuery[key] = 50;
        }
      })
      this.getUsers();
    },
    goToLearningPerformance(id,userNo,studying) {
      let path = `/student/${id}/learning-performance/${userNo}?studying=${studying}`
      this.resolveRouter(path)
    },
    onEditorButton(id) {
      let path = `/student/${id}/edit`
      this.resolveRouter(path)
    },
    onAdd() {
      let path = `/student/add`
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/student/${id}`
      this.resolveRouter(path)
    },
    getUsers() {
      let listQuery = {
        type: 2,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      getUsers(listQuery).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
  .demo-ruleForm-div {
    margin-top: 40px;
  }
  ::v-deep {
    .cell {
      color: black;
    }
  }
}
.form-avatar {
  position: relative;
  width: 90px;
  height: 90px;
}
.search-text {
  margin-bottom: 12px;
  color: #8e8e8e;
}
.page-content {
  background-color: #fff;
}
.page-box{
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
.page-content-row {
  padding: 30px 10px;
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(10, 1fr);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 140px;
}
.page-content-row>div:nth-last-child(1){
  min-width: 120px;
  grid-column-start: 10;
  text-align: right;
}
.page-content-row>div:nth-last-child(2){
  min-width: 120px;
}
.page-content-row>div:nth-last-child(3){
  min-width: 100px;
}
.button-el-el {
  margin-top: 30px;
}
.studentCode{
  color: #027915;
}
.isStudentCode{
  color: #9C0000;
}
</style>